export default __webpack_public_path__ + "static/media/income_proj_03.49c0bf70.png";